import { Loading } from '@components/loadling';
import { initSdk, onApiError } from '@proccess/api';
import { notistackRef } from '@proccess/ref/noti';
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from '@store';
import { AxiosResponse } from 'axios';
import Router from 'next/router';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

function* requestBanners({
  payload: { page, limit },
}: PayloadAction<{ page?: number; limit?: number }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.get('/admin/banners', {
        params: {
          page,
          limit,
        },
      })
    );
    if (response.data) {
      yield put(actions.saveBanners({ list: response.data }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestBanners() {
  yield takeLatest(actions.requestBanners, requestBanners);
}

function* requestBanner({ payload: { id } }: PayloadAction<{ id: string }>) {
  try {
    const response: AxiosResponse = yield call(() => initSdk.get(`/admin/banners/${id}`));
    if (response.data) {
      yield put(actions.saveBanner({ data: response.data.banner }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherrequestBanner() {
  yield takeLatest(actions.requestBanner, requestBanner);
}

function* updateBanner({ payload: { data } }: any) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/banners/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (response.data) {
      yield put(actions.saveBanner({ data: response.data.banner }));
      yield notistackRef.current &&
        call(notistackRef.current.enqueueSnackbar, 'Cập nhật thành công', {
          variant: 'success',
        });
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherupdateBanner() {
  yield takeLatest(actions.updateBanner, updateBanner);
}

function* deleteBanner({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/banners/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );
    if (response.data) {
      Router.back();
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherdeleteBanner() {
  yield takeLatest(actions.deleteBanner, deleteBanner);
}

function* requestPostionBanners() {
  try {
    const response: AxiosResponse = yield call(() => initSdk.get('/admin/banner_positions'));
    if (response.data) {
      yield put(actions.savePostionBanners({ list: response.data }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestPostionBanners() {
  yield takeLatest(actions.requestPostionBanners, requestPostionBanners);
}

function* requestDetailsPostionBanner({ payload: { id } }: PayloadAction<{ id: string }>) {
  try {
    const response: AxiosResponse = yield call(() => initSdk.get(`/admin/banner_positions/${id}`));
    if (response.data) {
      yield put(actions.saveDetailsPostionBanner({ data: response.data.banner_position }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestDetailsPostionBanner() {
  yield takeLatest(actions.requestDetailsPostionBanner, requestDetailsPostionBanner);
}

function* deleteBannerPosition({ payload: { id } }: PayloadAction<{ id: string }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.delete(`/admin/banner_positions/${id}`)
    );
    if (response.data) {
      yield put(actions.requestPostionBanners());
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherdeleteBannerPosition() {
  yield takeLatest(actions.deleteDetailsPostionBanner, deleteBannerPosition);
}

function* updateBannerPostion({ payload: { data } }: any) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/banner_positions/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (response.data) {
      yield put(actions.saveBanner({ data: response.data.banner_position }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherupdateBannerPostion() {
  yield takeLatest(actions.updateDetailsPostionBanner, updateBannerPostion);
}

function* createBanner({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.post('/admin/banners', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (response.data) {
      yield put(actions.saveBanner({ data: response.data.banner }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherCreateBanner() {
  yield takeLatest(actions.createBanner, createBanner);
}

const bannerSagas = function* root() {
  yield all([
    fork(watcherCreateBanner),
    fork(watcherRequestBanners),
    fork(watcherrequestBanner),
    fork(watcherupdateBanner),
    fork(watcherdeleteBanner),
    fork(watcherRequestPostionBanners),
    fork(watcherRequestDetailsPostionBanner),
    fork(watcherdeleteBannerPosition),
    fork(watcherupdateBannerPostion),
  ]);
};
export { bannerSagas };
